const CooperationList = () => import('@/vuepage/form-manage/cooperationList')
const DemoList = () => import('@/vuepage/form-manage/demoList')
export default [
    {
        path: '/cooperation-list',
        component: CooperationList,
        meta: [
            { name: '表单管理' },
            { name: '商务合作列表', activeRoute: '/cooperation-list' }
        ]
    },

    {
        path: '/demo-list',
        component: DemoList,
        name: '/demo-list',
        meta: [
            { name: '表单管理' },
            { name: '预约演示列表', activeRoute: '/demo-list' }
        ]
    }
]
